export default __webpack_public_path__ + "static/media/closet5-after3-768w.668e8d75.webp";